"use strict";

var _classCallCheck = require("/home/runner/work/ddctoolbox/ddctoolbox/src/website/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HttpRequest = void 0;

var http_headers_1 = require("./http-headers");

var HttpRequest = function HttpRequest(url) {
  _classCallCheck(this, HttpRequest);

  this.url = url;
  this.headers = new http_headers_1.HttpHeaders();
};

exports.HttpRequest = HttpRequest;